<template>
  <el-dialog
    ref="student"
    title="学生作业统计"
    :visible="studentDiolag"
    width="864px"
    @close="handleClose"
  >
    <span>{{user_name}}作业统计</span>
    <Lines
      :id="'student-line'"
      :height="250"
      :categories="categories"
      :series="series"
    ></Lines>
    <Pie
      :id="'student-pie'"
      :type="'student-pie'"
      :width="650"
      :height="220"
      :pieData="pieData"
    ></Pie>
  </el-dialog>
</template>
<script>
import Lines from "../components/Lines.vue";
import Pie from "../components/Pie.vue";
export default {
  components: { Lines, Pie },
  data() {
    return {};
  },
  props: {
    studentDiolag: {
      type: Boolean,
      default: false,
    },
    user_name: [String],
    pieData: {},
    categories: {},
    series: {},
  },
  watch: {
    pieData(val) {
      this.pieData = val;
    },
    categories(val) {
      this.categories = val;
    },
    series(val) {
      this.series = val;
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="scss" scoped>
span {
  font-size: 18px;
  color: #262c31;
}
#student-pie {
  margin: 30px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/components/StudentDiolag.vue